<template>
    <div class="doctors-box app">
        <div class="main-content">
            <div class="job-search clearfix">
                <div class="fr clearfix form-box">
                   <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item>
                            <el-select v-model="formInline.department_id" placeholder="请选择科室">
                                <el-option v-for="item in departmentList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-input @keyup.enter.native="onSubmit($event)" v-model="formInline.doctor_name" placeholder="请输入医生名字" @blur="formInline.doctor_name = changeValue($event)"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onSubmit" class="searchBtn">搜索</el-button>
                        </el-form-item>
                        </el-form>
                </div>
            </div>
            <ul class="main-ui clearfix">
                <li class="main-li fl hand-shape" v-for="(item,index) in dataList" :key="index" @click="goDetail(item.id)">
                    <div class="img-out tc color-blank">
                        <div class="avatar">
                            <img :src="item.img" :alt="item.name" class="img-responsive">
                        </div>
                        <div class="name fwb fs18 color-blank">{{item.name}}</div>
                        <div class="job-title fs14 color-blank">{{item.position}}</div>
                        <div class="depart color-gray color-gray txt_limit">{{item.departmentstr}}</div>
                    </div>
                    <div class="doctor-box">
                        <img src="../../assets/images/dash-line.png" alt="">
                        <div class="detail txt_limit2">{{item.description}}</div>
                    </div>
                </li>
            </ul>
            <el-col  :span="24" class="toolbar">
                <el-pagination
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="alltotal">
                </el-pagination>
            </el-col>
        </div>
    </div>
</template>

<script>
import seoArgs from '../../utils/setSeoArgs';

export default {
    props: {

    },
    components: {
        
    },
    data() {
        return {
            page: 1,//重新获取的当前的页码
            alltotal:10,//总的数据
            pageSize:9,//每一条的页数是10
            dataList:[],
            departmentList:[],
            status:0,
            formInline: {
                doctor_name: '', 
                department_id:'', 
            },
            short_name:this.$route.params.short_name,
        };
    },
    created() {
        const doctorSeoInfo = this.$cookies.get(this.api.cachePrex+'4')  || {};
        doctorSeoInfo.name = '医生介绍';
        seoArgs.setSeoArgs(doctorSeoInfo);

        this.getList();
        this.getDepList();
    },
    watch: {
        $route(to,from){
            this.short_name=to.params.short_name;
            sessionStorage.setItem('english_short_name',this.short_name);
            this.getList(1);
            this.getDepList();
        }
    },
    methods: {
        getDepList(){
            this.$axios.post(this.api.doctor.depList,{},res =>{
                let listdata=res.data;
                let cardlistarr=[{
                    id:null,
                    name:'全部'
                }]
                this.departmentList=cardlistarr.concat(listdata);
            });
        },
        getList(pageIndex) {
            if(pageIndex){
                this.page=pageIndex;
            }
            this.$axios.post(this.api.doctor.list+'?perpage='+this.pageSize+'&page='+this.page,{
                department_id:this.formInline.department_id,
                doctor_name:this.formInline.doctor_name
            },res =>{
                this.dataList=res.data;
                this.alltotal=Number(res.pageInfo.totalCount);
            },err =>{
                this.dataList=[];
            });
        },
        onSubmit(e) {
            if(e.target.value){
             this.formInline.doctor_name=e.target.value;
            }
            this.getList(1);
        },
        goDetail:function(id){
            this.$router.push('/doctorsDetail/'+this.short_name+'/'+id+'.html');
        },
        //页面改变
        handleCurrentChange(val) {
            this.page=val;
            this.getList();
        },
        //每页的页数改变
        handleSizeChange(val) {
            this.pageSize=val;
            this.getList();
        },
    },
    
};
</script>

<style scoped>
    .main-ui{padding:40px 0;}
    .main-li{margin-bottom:20px;padding:20px;width:380px;height:406px;background:rgba(255,255,255,1);box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);border-radius:5px;margin-right:30px;}
    .main-li:hover{box-shadow:0px 0px 10px 0px rgba(0,0,0,0.4);}
    .main-li:nth-child(3n){margin-right:0;}
    .main-li .avatar{width:120px;height:120px;border-radius:50%;overflow: hidden;margin:10px auto 30px;}
    .main-li .img-out .name{line-height:25px;height:25px;}
    .main-li .img-out .job-title{margin:10px;line-height:20px;height:20px;}
    .main-li .img-out .depart{line-height:20px;height:20px;}
</style>
<style>
.job-search{margin-top:40px;}
.job-search  .el-form-item__content,.job-search .el-input__icon{line-height:28px;}
.job-search .el-form-item__label{color:#666;font-size:14px;line-height:28px;}
.job-search .el-input__inner{width:160px;height:28px;line-height:28px;padding-left:10px;font-size:14px;background:#fff;border-radius:5px;border:1px solid rgba(217,217,217,1)}
.job-search .el-button.searchBtn{padding:0;height:28px;width:60px;border-radius:5px;}
</style>



// WEBPACK FOOTER //
// src/view/doctors/index.vue